<div *ngIf="false" class="sm:justify-between"></div>
<router-outlet></router-outlet>

<app-video-player
  (videoShowingChange)="videoShowingChange($event)"
  [(videoShowing)]="videoShowing"
  [videoError]="videoError"
  [videoHtml]="videoHtml"></app-video-player>
<ng-template #dialog let-data>
  <h1 mat-dialog-title class="text-lg font-medium">{{ data?.title }}</h1>
  <div>
    <ng-container *ngIf="data.message">{{ data?.message }}</ng-container>
    <ng-container *ngIf="data.template">
      <ng-container [ngTemplateOutlet]="data?.template" [ngTemplateOutletContext]="data?.templateContext"></ng-container>
    </ng-container>
  </div>
  <div class="mt-8 flex justify-between">
    <div>
      <ng-container *ngIf="data?.actions?.neutral">
        <button
          mat-button
          (click)="executeDialogAction(data?.actions?.neutral?.action()) || null"
          class="rounded border border-gray-300 px-4 py-2 text-xs font-medium uppercase tracking-widest text-gray-800 hover:bg-gray-100">
          {{ data?.actions?.neutral?.label || '-' }}
        </button>
      </ng-container>
    </div>
    <div class="space-x-2">
      <ng-container *ngIf="data?.actions?.negative">
        <button
          mat-button
          (click)="executeDialogAction(data?.actions?.negative?.action()) || null"
          class="rounded border border-gray-300 px-4 py-2 text-xs font-medium uppercase tracking-widest text-gray-800 hover:bg-gray-100">
          {{ data?.actions?.negative?.label || '-' }}
        </button>
      </ng-container>
      <ng-container *ngIf="data?.actions?.positive">
        <button
          mat-button
          (click)="executeDialogAction(data?.actions?.positive?.action()) || null"
          class="rounded px-4 py-2 text-xs font-medium uppercase tracking-widest text-white"
          [ngClass]="{
            'bg-primary-main hover:bg-primary-dark': !data?.style || data?.style == 'default',
            'bg-red-600 hover:bg-red-800': data?.style == 'danger'
          }">
          {{ data?.actions?.positive?.label || 'OK' }}
        </button>
      </ng-container>
    </div>
  </div>
</ng-template>
